import * as XLSX from 'xlsx';
import moment from 'moment';


export const historyExportToExcel = (data, addresses, user, filename = 'Gecmis_Izleme_Raporu.xlsx') => {
    if (data.length === 0) {
        console.error('Veri yok.');
        return;
    }

    // Rapor tarih aralıklarını belirleme
    const startDate = moment(data[0].createdat).subtract(3, 'hours').format('DD/MM/YYYY HH:mm:ss');
    const endDate = moment(data[data.length - 1].createdat).subtract(3, 'hours').format('DD/MM/YYYY HH:mm:ss');

    const headerData = [
        ['Geçmiş İzleme Raporu'],
        ['Raporu Alan:', user],
        ['Rapor Tarih Aralıkları:', `${startDate} - ${endDate}`],
        ['Plaka:', data[0].plate_number],
        ['Şasi Numarası:', data[0].chassisNumber],
        ['Kapı Numarası:', data[0].operation_number || '-'],
        [],
    ];

    const reportData = data.map((item, index) => ({
        Tarih: item.createdat
            ? moment(item.createdat).format('DD/MM/YYYY HH:mm:ss')
            : '-',
        Vites: item.currentgear || '-',
        Hız: !isNaN(item.wheelbasedspeed) ? `${item.wheelbasedspeed} km/h` : ' km/h',
        Adres: addresses[index] || 'Adres bulunamadı',
    }));

    const formatDate = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0'); // Gün
        const month = String(d.getMonth() + 1).padStart(2, '0'); // Ay (0-11 olduğundan +1 ekliyoruz)
        const year = d.getFullYear(); // Yıl
        const hours = String(d.getHours()).padStart(2, '0'); // Saat
        const minutes = String(d.getMinutes()).padStart(2, '0'); // Dakika
        const seconds = String(d.getSeconds()).padStart(2, '0'); // Saniye

        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    };

    const worksheetData = [
        ...headerData,
        ['Tarih', 'Vites', 'Hız', 'Adres'], // Başlık satırı
        ...reportData.map(item => {
            const row = Object.values(item);

            // Tarih sütununu al ve 3 saat geri al
            if (row[0]) {
                const originalDate = new Date(row[0]); // Tarihi al
                const adjustedDate = new Date(originalDate.getTime() - 3 * 60 * 60 * 1000); // 3 saat çıkar
                row[0] = formatDate(adjustedDate); // Formatlı tarih
            }

            return row;
        }),
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    const columnWidths = [
        {wch: 20},
        {wch: 7},
        {wch: 10},
        {wch: 60},
    ];

    worksheet['!cols'] = columnWidths;

    // Excel dosyasını oluşturma ve kaydetme
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Geçmiş İzleme Raporu');
    XLSX.writeFile(workbook, filename);
};